module.exports = __webpack_public_path__ + "05d2873ecc8a206e55b7e3d952426430.MP3";